import { connect } from 'react-redux'
import BookmarkUI from './BookmarkUI'
import { Dispatch } from 'redux';
import BookmarkDispatch from './model';
import ApplicationState from '../../../../../../../ApplicationState';
import IState from '../../../../../../Util/IState';
import IDispatcher from '../../../../../../Util/IDispatcher';
import { ActionType } from '../../Actions/ActionTypes';
import BookmarkState from '../../State/BookmarkState';
import VilgramFileDto from '../../../../../../../dto/VilagramFileDto';
import { ActionType as FileActionTypes } from '../../../File/Actions/ActionTypes';

const mapStateToProps = (state: ApplicationState): IState<BookmarkState> => {
    return {
        state: state.bookmark
    }
}

const mapDispatchToProps = (dispatch: Dispatch): IDispatcher<BookmarkDispatch> => ({
    dispatcher: {
        show: () => {
            dispatch({
                type: ActionType.BOOKMARK_SHOW
            })
        },
        onItemClicked: (file: VilgramFileDto) => {
            dispatch({
                type: FileActionTypes.FILE_SHOW,
                data: file
            })
        }
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(BookmarkUI)